import { render, staticRenderFns } from "./QuizAsideDiscount.vue?vue&type=template&id=1c8828a6&scoped=true&"
import script from "./QuizAsideDiscount.vue?vue&type=script&lang=js&"
export * from "./QuizAsideDiscount.vue?vue&type=script&lang=js&"
import style0 from "./QuizAsideDiscount.vue?vue&type=style&index=0&id=1c8828a6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8828a6",
  null
  
)

export default component.exports